export const frontmatter = {
    "draft": true,
    "title": "Agentes",
    "sidebar_group": "referencia",
    "sidebar_label": "Agentes",
    "sidebar_order": 7
}

export const toc = []